import styled from 'styled-components'

export const Section = styled.section`
  margin-bottom: 3rem;
  scroll-margin-top: 100px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const SectionTitle = styled.h2`
  font-size: 1.75rem;
  color: var(--color-primary);
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;

  svg {
    width: 24px;
    height: 24px;
  }
`

export const SubSection = styled.div`
  margin: 2rem 0;
  padding-left: 1rem;
  border-left: 2px solid rgba(64, 224, 208, 0.2);
  scroll-margin-top: 100px;

  &:hover {
    border-left-color: var(--color-primary);
  }
`

export const SubSectionTitle = styled.h3`
  font-size: 1.25rem;
  color: var(--color-primary);
  margin-bottom: 1rem;
  display: flex;
  align-items: center;

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    background: var(--color-primary);
    border-radius: 50%;
    margin-right: 0.75rem;
    margin-left: -1.4rem;
  }
`

export const SubTitle = styled.h3`
  font-size: 1.25rem;
  color: var(--color-primary);
  margin-bottom: 1rem;
`

export const Text = styled.p`
  color: var(--color-text-secondary);
  line-height: 1.8;
  margin-bottom: 1.5rem;
  font-size: 1.1rem;

  &:last-child {
    margin-bottom: 0;
  }
`

export const List = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0 0 1.5rem;

  li {
    color: var(--color-text-secondary);
    margin-bottom: 1rem;
    padding-left: 1.5rem;
    position: relative;
    line-height: 1.6;

    &::before {
      content: "•";
      color: var(--color-primary);
      position: absolute;
      left: 0;
    }

    ul {
      margin-top: 0.5rem;
      margin-left: 1rem;
    }
  }
`

export const CodeBlock = styled.pre`
  background: rgba(0, 0, 0, 0.3);
  padding: 1.5rem;
  border-radius: 8px;
  overflow-x: auto;
  margin: 1.5rem 0;
  font-family: 'Fira Code', monospace;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #e2e8f0;
  border: 1px solid rgba(64, 224, 208, 0.2);
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 1.5rem 0;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  overflow: hidden;

  th, td {
    padding: 1rem;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  th {
    background: rgba(64, 224, 208, 0.1);
    color: var(--color-primary);
    font-weight: 600;
  }

  td {
    color: var(--color-text-secondary);
  }
`

export const Quote = styled.blockquote`
  margin: 1.5rem 0;
  padding: 1rem 1.5rem;
  border-left: 4px solid var(--color-primary);
  background: rgba(64, 224, 208, 0.05);
  border-radius: 0 8px 8px 0;

  p {
    color: var(--color-text);
    font-style: italic;
    margin: 0;
  }
`
